import { createAction } from '@reduxjs/toolkit';

export const LOGS_FETCH_DATA_INIT = createAction('LOGS_FETCH_DATA_INIT');
export const LOGS_FETCH_DATA_SUCCESS = createAction(
  'LOGS_FETCH_DATA_SUCCESS'
);
export const LOGS_FETCH_DATA_FAIL = createAction('LOGS_FETCH_DATA_FAIL');
